export default __webpack_public_path__ + "static/media/box1.34212d60.png";